import PropTypes from 'prop-types';
import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import PageSection from './PageSection';
import * as styles from './TestimonialGroup.module.scss';

const TestimonialGroup = ({ testimonials, itemsPerRow = 2 }) => {
  return (
    <PageSection className={styles.section} data-analytics-section={'testimonial-group'}>
      <div className={[styles.cardGrid, itemsPerRow === 3 ? styles.threeColumn : ''].join(' ')}>
        {testimonials.map((testimonial, i) => (
          <div
            data-analytics-component={'testimonial'}
            data-analytics-id={testimonial.attribution}
            key={i}
            className={styles.quoteContainer}
          >
            <div className={styles.logo}>
              <ContentfulImage alt={testimonial.logo.title} imageFragment={testimonial.logo} />
            </div>
            <p>{testimonial.quote?.quote}</p>
            <div className={styles.attribution}>
              <span>{testimonial.attribution}</span>
              <span>{testimonial.company}</span>
            </div>
          </div>
        ))}
      </div>
    </PageSection>
  );
};

TestimonialGroup.propTypes = {
  testimonials: PropTypes.array.isRequired,
  itemsPerRow: PropTypes.number,
};

export default TestimonialGroup;
